id: '**Entity_NotSyncedNotification_Task_Id**'
priority: 3
name: '**Entity_NotSyncedNotification_Task_Name**'
description: '**Entity_NotSyncedNotification_Task_Description**'
valueTableName: '**Entity_NotSyncedNotification_Table_Name**'
ignoreRemoval: true
ignoreChange: false
type: AUDIT # REPORT, REFERENCE, CONFIG, AUDIT, SYNCHRONIZATION
